import { useEffect } from 'react'
import useEdgeDataFetcher from './useEdgeDataFetcher'

export default function useVoiVin({ saveMultipleQuestionRaw, prospectDocuments }, { dealerIsDirectToKBB, acceptsRV, isAdmin, isDigitalRetail, cobrandingInfo, ...exprienceState }, location) {
  const lfnQ = 'qrv/LookingForNewCars'
  const lfuQ = 'qrv/LookingForUsedCars'
  const lfcQ = 'qrv/LookingForCertifiedCars'
  const vvQ = 'qrv/VoiVin'
  const qLeadType = 'qrv/LeadType'
  const qYearRange = 'qrv/YearRange'
  const qMake = 'qrv/Make'
  const qModel = 'qrv/Model'
  const qMM1 = 'qrv/MakeModel1'

  const dataPack = prospectDocuments && prospectDocuments.documents && prospectDocuments.documents.find(document => document.canonicalName === 'replacementVehicle/supplement')
  const shouldUseVoivin = !(isDigitalRetail || dealerIsDirectToKBB || !acceptsRV || isDigitalRetail)

  const avaiableQuestionTypes = cobrandingInfo && cobrandingInfo.replacementVehicleTypes ? cobrandingInfo.replacementVehicleTypes : [lfcQ, lfnQ, lfuQ]

  const rvMakesModels = (dataPack && dataPack.items['makesModels'].values) || []
  const [data] = useEdgeDataFetcher(shouldUseVoivin && prospectDocuments && location.initQueryParams.voivin && `/vin/replacementvehicle/vindecode/${location.initQueryParams.voivin}?a=b`)

  function getMakeModel1(makeName, modelName) {
    const findrvModels = rvMakesModels && rvMakesModels.find(mm => mm.label === makeName)
    const rvModels = findrvModels ? findrvModels.values : []
    const model = rvModels.find(i => i.label === modelName)
    return model && model.id
  }

  useEffect(() => {
    if (shouldUseVoivin && location.initQueryParams.voivin && data && rvMakesModels.length) {
      const anwserYearRange = `${data.yearId},${data.yearId}`
      const answerMM1 = getMakeModel1(data.makeName, data.modelName)

      const questionAnswers = []

      if (data.yearId) {
        questionAnswers.push([qYearRange, { c: anwserYearRange }])
      }
      if (data.makeName) {
        questionAnswers.push([qMake, { c: data.makeName }])
      }
      if (data.model) {
        questionAnswers.push([qModel, { c: data.modelName }])
      }
      if (answerMM1) {
        questionAnswers.push([qMM1, { c: answerMM1 }])
      }
      if (data.isNewCar && avaiableQuestionTypes.includes(lfnQ)) {
        questionAnswers.push([lfnQ, { v: 0 }])
      }
      if (!data.isNewCar && avaiableQuestionTypes.includes(lfuQ)) {
        questionAnswers.push([lfuQ, { v: 0 }])
      }
      questionAnswers.push([qLeadType, { v: 'OptIn' }])
      questionAnswers.push([vvQ, { c: location.initQueryParams.voivin }])

      saveMultipleQuestionRaw(
        questionAnswers.map(i => i[0]),
        questionAnswers.map(i => i[1]),
        true
      )
    }
  }, [data, rvMakesModels])
}
